export { VendorsPage } from './VendorsPage';
